export default {
      id: "lc-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#lc",
      toString: function () {
        return this.url;
      }
    }